import { client } from './api-client';

export const getBanners = () => client.get(`v2/banners`);
